<script setup lang="ts">
import { useAuth } from "~/store/auth";
import { useSettings } from "~/store/settings";

const auth = useAuth();
const router = useRouter();
const route = useRoute();
const panel = ref<HTMLElement | null>();
const settings = useSettings();
const config = useRuntimeConfig();
const colorMode = useColorMode();

useHead({
	script: [
		{
			src: config.public.notificationPanelDomain,
			type: "module",
		},
	],
});

const handleNotificationMessage = (data: any) => {
	const { action, actionValue } = data.detail;
	switch (action.toUpperCase()) {
		case "NAVIGATETO":
			router.push(actionValue);
			auth.modals.notifications = false;
			break;
		case "LAUNCHGAME":
			if (settings.isNativeApp && settings.hasNativeLobby) {
				const vertical = actionValue && actionValue.includes("lobby") ? actionValue.split("/")[2] : null;
				useNuxtApp().$messageHandler({
					message: "navigateTo",
					data: {
						path: actionValue,
						vertical,
					},
				});
			} else {
				router.push(actionValue);
			}
			break;
		case "NAVIGATENEWTAB":
			window.open(actionValue);
			break;
		// case 'LAUNCH':
		//     this.handleLaunch(actionValue)
		//     break
		case "ACCOUNT":
			router.push({ query: { ...route.query, account: "deposit" } });
			break;
		// case 'MOREINFO':
		//     window.betwaySynapseInstance.showMoreInfoDialog(actionValue)
		//     break
		default:
			break;
	}
};

const handleClose = () => {
	auth.modals.notifications = false;
	const queryParams = { ...route.query };
	delete queryParams.inbox;
	router.replace({ query: queryParams });
};

const handleNotificationCount = (data: any) => {
	if (data.detail) {
		auth.notifications = data.detail.unread;
	}
};

onMounted(() => {
	if (panel.value) {
		panel.value.addEventListener("updateNotificationsCount", handleNotificationCount);
		panel.value.addEventListener("closePanel", handleClose);
		panel.value.addEventListener("handleNotificationActions", handleNotificationMessage);
	}
});

onUnmounted(() => {
	if (panel.value) {
		panel.value.removeEventListener("updateNotificationsCount", handleNotificationCount);
		panel.value.removeEventListener("closePanel", handleClose);
		panel.value.removeEventListener("handleNotificationActions", handleNotificationMessage);
	}
});

watchEffect(() => {
	if (panel.value) {
		if (auth.modals.notifications) {
			panel.value.setAttribute("opened", "true");
		} else {
			panel.value.removeAttribute("opened");
		}
	}
});
</script>

<template>
	<notifications-panel
		ref="panel"
		id="notifications-panel"
		date-limit-in-months="6"
		licence="betwayafrica"
		storage-type="cookie"
		key-name="betway-auth"
		opened="false"
		enable-push-notifications="on"
		limit="20"
		:preferred-color-scheme="colorMode.value"
		:region-code="settings.config?.regionCode"
		:culture-code="settings.locale"
	/>
</template>
